import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ConfirmationDialogButtonType, ConfirmationDialogService, IConfirmationDialogModel } from '@frontend/sports/modal/feature';
import { TrackingType } from '@frontend/sports/tracking/feature';

import { EditBetBetDialogBaseService } from './edit-bet-bet-dialog-base.service';

@Injectable()
export class EditBetBetWonDialogService extends EditBetBetDialogBaseService {
    constructor(
        confirmationDialog: ConfirmationDialogService,
        private sitecore: Sitecore,
    ) {
        super(confirmationDialog);
    }

    protected getDialogModel(): IConfirmationDialogModel {
        return {
            title: this.sitecore.betslip.editBet.betWonTitle,
            message: this.sitecore.betslip.editBet.betWonMessage,
            cssClass: 'edit-bet-confirmation-dialog',
            buttons: [
                {
                    buttonType: ConfirmationDialogButtonType.Ok,
                    buttonTitle: this.sitecore.betslip.editBet.backToMyBets,
                    cssClass: 'btn prominent',
                },
            ],
            tracking: {
                name: 'Sports_EditBet_BetWon_Screen_Loaded',
                type: TrackingType.Referring,
            },
        };
    }
}
